<!--page starts-->
 <section class="page-wrapper">
    <div class="news-hero-section margin-top-152 cf" [ngStyle]="{'background-image':'url(' + bannerList?.file + ')'}">
        <div class="container">
           <div class="news-hero-detail">
           	   <div class="news-arrow">
                   <a href="javascript:void(0)"><img src="assets/images/down-arrow.svg"></a>  
               </div>
           </div>
        </div>
    </div>
    <div class="news-bottom-section cf">
       <div class="container">
           <div class="news-bottom-detail cf" *ngIf="videoList?.length > 0">
               <div class="titel-box">
	      	 		<h2 class="titel-name">Foxes TV</h2>
	      	 	</div>
	      	 	<div class="video-bottom-section">
                    <div class="latest-new-detail cf">
		      	 		<div class="latest-video-box" *ngFor="let video of videoList">
		      	 			<div class="latest-video-box-top">
			      	 			
			      	 				<div class="latest-new-image">
										<img [src]="video?.thumbnail_image">
			      	 				</div>
									<div class="latest-new-image-hover">
										<img [src]="video?.image">
									</div> 
			      	 				<div class="video-overlay">
	                                    <div  class="video-paly-icon">
											<a href="{{video?.video}}" class="popup-youtube">
											    <img src="assets/images/play-button.png">
											</a>
										</div>
	                                    <div class="video-overlay-content"><div class="video-overlay-text"><p>{{video?.title}}</p></div></div>
			      	 				</div>
				      	 		
				      	 	</div>
		      	 		</div>
		      	 		<!-- <div class="latest-video-box">
		      	 			<div class="latest-video-box-top">
			      	 			<a href="#">
			      	 				<div class="latest-new-image">
			      	 					<img src="assets/images/header3.jpg">
			      	 				</div>
			      	 				<div class="video-overlay">
	                                     <div class="video-paly-icon"><a href="assets/images/videoplayback.mp4" class="popup-youtube"><img src="assets/images/play-button.png"></a></div>
	                                     <div class="video-overlay-content"><div class="video-overlay-text"><p>Sean Jarvis Addresses Running Foxes' Rebranding Project</p></div></div>
			      	 				</div>
				      	 		</a>
				      	 	</div>
		      	 		</div>
		      	 		<div class="latest-video-box">
		      	 			<div class="latest-video-box-top">
			      	 			<a href="#">
			      	 				<div class="latest-new-image">
			      	 					<img src="assets/images/letest-new-image.jpg">
			      	 				</div>
			      	 				<div class="video-overlay">
	                                     <div class="video-paly-icon"><a href="assets/images/videoplayback.mp4" class="popup-youtube"><img src="assets/images/play-button.png"></a></div>
	                                     <div class="video-overlay-content"><div class="video-overlay-text"><p>Sean Jarvis Addresses Running Foxes' Rebranding Project</p></div></div>
			      	 				</div>
				      	 		</a>
				      	 	</div>
		      	 		</div>
		      	 		<div class="latest-video-box">
		      	 			<div class="latest-video-box-top">
			      	 			<a href="#">
			      	 				<div class="latest-new-image">
			      	 					<img src="assets/images/letest-new-image.jpg">
			      	 				</div>
			      	 				<div class="video-overlay">
	                                     <div class="video-paly-icon"><a href="assets/images/videoplayback.mp4" class="popup-youtube"><img src="assets/images/play-button.png"></a></div>
	                                     <div class="video-overlay-content"><div class="video-overlay-text"><p>Sean Jarvis Addresses Running Foxes' Rebranding Project</p></div></div>
			      	 				</div>
				      	 		</a>
				      	 	</div>
		      	 		</div>
		      	 		<div class="latest-video-box">
		      	 			<div class="latest-video-box-top">
			      	 			<a href="#">
			      	 				<div class="latest-new-image">
			      	 					<img src="assets/images/header3.jpg">
			      	 				</div>
			      	 				<div class="video-overlay">
	                                     <div class="video-paly-icon"><a href="assets/images/videoplayback.mp4" class="popup-youtube"><img src="assets/images/play-button.png"></a></div>
	                                     <div class="video-overlay-content"><div class="video-overlay-text"><p>Sean Jarvis Addresses Running Foxes' Rebranding Project</p></div></div>
			      	 				</div>
				      	 		</a>
				      	 	</div>
		      	 		</div>
		      	 		<div class="latest-video-box">
		      	 			<div class="latest-video-box-top">
			      	 			<a href="#">
			      	 				<div class="latest-new-image">
			      	 					<img src="assets/images/letest-new-image.jpg">
			      	 				</div>
			      	 				<div class="video-overlay">
	                                     <div class="video-paly-icon"><a href="assets/images/videoplayback.mp4" class="popup-youtube"><img src="assets/images/play-button.png"></a></div>
	                                     <div class="video-overlay-content"><div class="video-overlay-text"><p>Sean Jarvis Addresses Running Foxes' Rebranding Project</p></div></div>
			      	 				</div>
				      	 		</a>
				      	 	</div>
		      	 		</div>
		      	 		<div class="latest-video-box">
		      	 			<div class="latest-video-box-top">
			      	 			<a href="#">
			      	 				<div class="latest-new-image">
			      	 					<img src="assets/images/letest-new-image.jpg">
			      	 				</div>
			      	 				<div class="video-overlay">
	                                     <div class="video-paly-icon"><a href="assets/images/videoplayback.mp4" class="popup-youtube"><img src="assets/images/play-button.png"></a></div>
	                                     <div class="video-overlay-content"><div class="video-overlay-text"><p>Sean Jarvis Addresses Running Foxes' Rebranding Project</p></div></div>
			      	 				</div>
				      	 		</a>
				      	 	</div>
		      	 		</div>
		      	 		<div class="latest-video-box">
		      	 			<div class="latest-video-box-top">
			      	 			<a href="#">
			      	 				<div class="latest-new-image">
			      	 					<img src="assets/images/header3.jpg">
			      	 				</div>
			      	 				<div class="video-overlay">
	                                     <div class="video-paly-icon"><a href="assets/images/videoplayback.mp4" class="popup-youtube"><img src="assets/images/play-button.png"></a></div>
	                                     <div class="video-overlay-content"><div class="video-overlay-text"><p>Sean Jarvis Addresses Running Foxes' Rebranding Project</p></div></div>
			      	 				</div>
				      	 		</a>
				      	 	</div>
		      	 		</div>
		      	 		<div class="latest-video-box">
		      	 			<div class="latest-video-box-top">
			      	 			<a href="#">
			      	 				<div class="latest-new-image">
			      	 					<img src="assets/images/letest-new-image.jpg">
			      	 				</div>
			      	 				<div class="video-overlay">
	                                     <div class="video-paly-icon"><a href="assets/images/videoplayback.mp4" class="popup-youtube"><img src="assets/images/play-button.png"></a></div>
	                                     <div class="video-overlay-content"><div class="video-overlay-text"><p>Sean Jarvis Addresses Running Foxes' Rebranding Project</p></div></div>
			      	 				</div>
				      	 		</a>
				      	 	</div>
		      	 		</div>
		      	 		<div class="latest-video-box">
		      	 			<div class="latest-video-box-top">
			      	 			<a href="#">
			      	 				<div class="latest-new-image">
			      	 					<img src="assets/images/letest-new-image.jpg">
			      	 				</div>
			      	 				<div class="video-overlay">
	                                     <div class="video-paly-icon"><a href="assets/images/videoplayback.mp4" class="popup-youtube"><img src="assets/images/play-button.png"></a></div>
	                                     <div class="video-overlay-content"><div class="video-overlay-text"><p>Sean Jarvis Addresses Running Foxes' Rebranding Project</p></div></div>
			      	 				</div>
				      	 		</a>
				      	 	</div>
		      	 		</div>
		      	 		<div class="latest-video-box">
		      	 			<div class="latest-video-box-top">
			      	 			<a href="#">
			      	 				<div class="latest-new-image">
			      	 					<img src="assets/images/header3.jpg">
			      	 				</div>
			      	 				<div class="video-overlay">
	                                     <div class="video-paly-icon"><a href="assets/images/videoplayback.mp4" class="popup-youtube"><img src="assets/images/play-button.png"></a></div>
	                                     <div class="video-overlay-content"><div class="video-overlay-text"><p>Sean Jarvis Addresses Running Foxes' Rebranding Project</p></div></div>
			      	 				</div>
				      	 		</a>
				      	 	</div>
		      	 		</div>
		      	 		<div class="latest-video-box">
		      	 			<div class="latest-video-box-top">
			      	 			<a href="#">
			      	 				<div class="latest-new-image">
			      	 					<img src="assets/images/letest-new-image.jpg">
			      	 				</div>
			      	 				<div class="video-overlay">
	                                     <div class="video-paly-icon"><a href="assets/images/videoplayback.mp4" class="popup-youtube"><img src="assets/images/play-button.png"></a></div>
	                                     <div class="video-overlay-content"><div class="video-overlay-text"><p>Sean Jarvis Addresses Running Foxes' Rebranding Project</p></div></div>
			      	 				</div>
				      	 		</a>
				      	 	</div>
		      	 		</div>
		      	 		<div class="latest-video-box">
		      	 			<div class="latest-video-box-top">
			      	 			<a href="#">
			      	 				<div class="latest-new-image">
			      	 					<img src="assets/images/letest-new-image.jpg">
			      	 				</div>
			      	 				<div class="video-overlay">
	                                     <div class="video-paly-icon"><a href="assets/images/videoplayback.mp4" class="popup-youtube"><img src="assets/images/play-button.png"></a></div>
	                                     <div class="video-overlay-content"><div class="video-overlay-text"><p>Sean Jarvis Addresses Running Foxes' Rebranding Project</p></div></div>
			      	 				</div>
				      	 		</a>
				      	 	</div>
		      	 		</div>
		      	 		<div class="latest-video-box">
		      	 			<div class="latest-video-box-top">
			      	 			<a href="#">
			      	 				<div class="latest-new-image">
			      	 					<img src="assets/images/header3.jpg">
			      	 				</div>
			      	 				<div class="video-overlay">
	                                     <div class="video-paly-icon"><a href="assets/images/videoplayback.mp4" class="popup-youtube"><img src="assets/images/play-button.png"></a></div>
	                                     <div class="video-overlay-content"><div class="video-overlay-text"><p>Sean Jarvis Addresses Running Foxes' Rebranding Project</p></div></div>
			      	 				</div>
				      	 		</a>
				      	 	</div>
		      	 		</div>
		      	 		<div class="latest-video-box">
		      	 			<div class="latest-video-box-top">
			      	 			<a href="#">
			      	 				<div class="latest-new-image">
			      	 					<img src="assets/images/letest-new-image.jpg">
			      	 				</div>
			      	 				<div class="video-overlay">
	                                     <div class="video-paly-icon"><a href="assets/images/videoplayback.mp4" class="popup-youtube"><img src="assets/images/play-button.png"></a></div>
	                                     <div class="video-overlay-content"><div class="video-overlay-text"><p>Sean Jarvis Addresses Running Foxes' Rebranding Project</p></div></div>
			      	 				</div>
				      	 		</a>
				      	 	</div>
		      	 		</div>
		      	 		<div class="latest-video-box">
		      	 			<div class="latest-video-box-top">
			      	 			<a href="#">
			      	 				<div class="latest-new-image">
			      	 					<img src="assets/images/letest-new-image.jpg">
			      	 				</div>
			      	 				<div class="video-overlay">
	                                     <div class="video-paly-icon"><a href="assets/images/videoplayback.mp4" class="popup-youtube"><img src="assets/images/play-button.png"></a></div>
	                                     <div class="video-overlay-content"><div class="video-overlay-text"><p>Sean Jarvis Addresses Running Foxes' Rebranding Project</p></div></div>
			      	 				</div>
				      	 		</a>
				      	 	</div>
		      	 		</div>
		      	 		<div class="latest-video-box">
		      	 			<div class="latest-video-box-top">
			      	 			<a href="#">
			      	 				<div class="latest-new-image">
			      	 					<img src="assets/images/header3.jpg">
			      	 				</div>
			      	 				<div class="video-overlay">
	                                     <div class="video-paly-icon"><a href="assets/images/videoplayback.mp4" class="popup-youtube"><img src="assets/images/play-button.png"></a></div>
	                                     <div class="video-overlay-content"><div class="video-overlay-text"><p>Sean Jarvis Addresses Running Foxes' Rebranding Project</p></div></div>
			      	 				</div>
				      	 		</a>
				      	 	</div>
		      	 		</div>
		      	 		<div class="latest-video-box">
		      	 			<div class="latest-video-box-top">
			      	 			<a href="#">
			      	 				<div class="latest-new-image">
			      	 					<img src="assets/images/letest-new-image.jpg">
			      	 				</div>
			      	 				<div class="video-overlay">
	                                     <div class="video-paly-icon"><a href="assets/images/videoplayback.mp4" class="popup-youtube"><img src="assets/images/play-button.png"></a></div>
	                                     <div class="video-overlay-content"><div class="video-overlay-text"><p>Sean Jarvis Addresses Running Foxes' Rebranding Project</p></div></div>
			      	 				</div>
				      	 		</a>
				      	 	</div>
		      	 		</div>
		      	 		<div class="latest-video-box">
		      	 			<div class="latest-video-box-top">
			      	 			<a href="#">
			      	 				<div class="latest-new-image">
			      	 					<img src="assets/images/letest-new-image.jpg">
			      	 				</div>
			      	 				<div class="video-overlay">
	                                     <div class="video-paly-icon"><a href="assets/images/videoplayback.mp4" class="popup-youtube"><img src="assets/images/play-button.png"></a></div>
	                                     <div class="video-overlay-content"><div class="video-overlay-text"><p>Sean Jarvis Addresses Running Foxes' Rebranding Project</p></div></div>
			      	 				</div>
				      	 		</a>
				      	 	</div>
		      	 		</div>
		      	 		<div class="latest-video-box">
		      	 			<div class="latest-video-box-top">
			      	 			<a href="#">
			      	 				<div class="latest-new-image">
			      	 					<img src="assets/images/header3.jpg">
			      	 				</div>
			      	 				<div class="video-overlay">
	                                     <div class="video-paly-icon"><a href="assets/images/videoplayback.mp4" class="popup-youtube"><img src="assets/images/play-button.png"></a></div>
	                                     <div class="video-overlay-content"><div class="video-overlay-text"><p>Sean Jarvis Addresses Running Foxes' Rebranding Project</p></div></div>
			      	 				</div>
				      	 		</a>
				      	 	</div>
		      	 		</div>
		      	 		<div class="latest-video-box">
		      	 			<div class="latest-video-box-top">
			      	 			<a href="#">
			      	 				<div class="latest-new-image">
			      	 					<img src="assets/images/letest-new-image.jpg">
			      	 				</div>
			      	 				<div class="video-overlay">
	                                     <div class="video-paly-icon"><a href="assets/images/videoplayback.mp4" class="popup-youtube"><img src="assets/images/play-button.png"></a></div>
	                                     <div class="video-overlay-content"><div class="video-overlay-text"><p>Sean Jarvis Addresses Running Foxes' Rebranding Project</p></div></div>
			      	 				</div>
				      	 		</a>
				      	 	</div>
		      	 		</div> -->
		      	 	</div>
		      	 	<div class="news-tab-btn" *ngIf="!videoList_last_page">
                        <a (click)="getMoreVideos()">View More</a>
		      	 	</div>
	      	 	</div>
           </div> 
       </div>
    </div>
</section><!-- page ends-->